var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BridgeRegistry__factory, } from "@textile/eth-storage-bridge";
import { REGISTRY_ID } from "./utils.js";
function initRegistry(contract) {
    return {
        listProviders: () => __awaiter(this, void 0, void 0, function* () {
            return contract.listProviders();
        }),
    };
}
export function create(account, contractId = REGISTRY_ID) {
    const contract = BridgeRegistry__factory.connect(contractId, account);
    return initRegistry(contract);
}
//# sourceMappingURL=registry.js.map